<template>
  <div class="empty-wrapper">
    <div class="empty-text">{{ text }}</div>
    <div v-if="buttonText" class="empty-btn buttons">
      <el-button type="primary" class="blue-bg" @click="$emit('emptyClick')">{{
        buttonText
      }}</el-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    text: {
      type: String,
      default() {
        return '空空如也!'
      }
    },
    buttonText: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
@import "@/assets/css/buttons.scss";
.empty-wrapper {
  padding: 120px 0 30px;
  background: url(../../static/enterprise/empty.png) no-repeat center top;
  text-align: center;
  color: #999;
  font-size: 14px;
  line-height: 24px;
  .empty-btn {
    padding-top: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/model/isEmpty.vue